import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import useToken from '../context/useToken';
import axios from 'axios';
import { BASE_URL } from '../utils';

const AboutHome = () => {
  const token = useToken();
  const [homeInfo, setHomeInfo] = useState({});
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [newImage, setNewImage] = useState('');
  const [listContent, setListContent] = useState('');
  const [showModal, setShowModal] = useState(false);

  const fetchHomeInfo = async () => {
    try {
      const response = await axios.get(`${BASE_URL}home-info`, {
        headers: {
          'accept': '*/*'
        }
      });
      setHomeInfo(response.data[1]);
      setTitle(response.data[1].heading || 'Working Process');
      setSubtitle(response.data[1].description || 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.');
      setNewImage(response.data[1].image || '');
      setListContent(response.data[1].description || '');
    } catch (error) {
      console.error('Error fetching home info:', error);
    }
  };

  useEffect(() => {
    fetchHomeInfo();
  }, []);

  const handleSave = async () => {
    try {
      const formData = new FormData();
      formData.append('heading', title);
      formData.append('description', subtitle);
      formData.append('isCtaActive', true);
      formData.append('image', newImage);

      const apiUrl = `${BASE_URL}home-info/${homeInfo._id}`;
      const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      };

      const response = await axios.put(apiUrl, formData, { headers });

      if (response.status === 200) {
        console.log('Data updated successfully:', response.data);
        setShowModal(false); // Close the modal
        fetchHomeInfo(); // Refresh data after save
      }
    } catch (error) {
      console.error('Error updating data:', error);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewImage(file);
    }
  };

  return (
    <div className="py-10 ">
      <div className="flex items-center justify-center py-12">
        <div className="flex flex-col md:flex-row-reverse w-3/4 max-w-6xl rounded-md overflow-hidden">
          <div className="w-full md:w-[47%] shadow-xl md:mr-10 mb-6 md:mb-0">
            <img
              src={newImage || 'https://via.placeholder.com/600'}
              alt="Working Process"
              className="object-cover w-full rounded-lg h-full"
            />
          </div>

          <div className="w-full md:w-1/2 p-[35px] mt-0 md:mt-10">
            <h2 className="flex items-center text-4xl md:text-6xl font-bold text-[#1f1f25] mb-4">
              {title}
              {token && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="h-12 w-12 cursor-pointer text-gray-500 hover:text-gray-700"
                  onClick={() => setShowModal(true)}
                >
                  <path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
                  <path d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
                </svg>
              )}
            </h2>
            
            <p className="text-base md:text-lg text-[#717173] mb-6">
              {subtitle}
            </p>

            <div
              className="text-[#1f1f25] text-[16px] font-medium mb-6 space-y-5"
              dangerouslySetInnerHTML={{ __html: listContent }}
            ></div>
              {/* <Link to="/contact">
                <button
                  className="px-8 py-3 mt-10 text-md font-medium rounded-md relative overflow-hidden transition-transform duration-300 transform hover:translate-y-[-4px]"
                  style={{
                    backgroundColor: '#25a182',
                    color: '#fff',
                  }}
                >
                  {'SEE HOW IT WORKS'}
                </button>
              </Link> */}
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 w-[600px]">
            <h3 className="text-2xl font-semibold mb-4">Edit Working Process</h3>

            <input
              type="text"
              placeholder="Enter Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="p-2 border border-gray-300 rounded w-full mb-4"
            />

            <textarea
              placeholder="Enter Subtitle"
              value={subtitle}
              onChange={(e) => setSubtitle(e.target.value)}
              className="p-2 border border-gray-300 rounded w-full mb-4"
            />

            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="w-full p-2 border border-gray-300 rounded mb-4"
            />

            <div className="mb-4">
              <CKEditor
                editor={ClassicEditor}
                data={listContent}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setListContent(data);
                }}
              />
            </div>

            <div className="flex justify-end gap-4">
              <button
                onClick={() => setShowModal(false)}
                className="bg-red-400 text-white px-6 py-2 rounded shadow hover:bg-red-500"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="bg-[#25a182] text-white px-6 py-2 rounded shadow hover:bg-[#1f795e]"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutHome;
